// extracted by mini-css-extract-plugin
export default {"legend":"styles_legend__WMk+O"};